import {
  WS_FRIDAY,
  WS_MONDAY,
  WS_SATURDAY,
  WS_SUNDAY,
  WS_THURSDAY,
  WS_TUESDAY,
  WS_WEDNESDAY,
} from '@pages/WorkSchedule/constants/filters';

import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const defaultSelectedDays: NWorkSchedule.SelectedDays = {
  [WS_MONDAY]: false,
  [WS_TUESDAY]: false,
  [WS_WEDNESDAY]: false,
  [WS_THURSDAY]: false,
  [WS_FRIDAY]: false,
  [WS_SATURDAY]: false,
  [WS_SUNDAY]: false,
};
